export default "__VITE_ASSET__DPLrtJXy__"